
function LoginButton({ switchLogin }) {
  
  return (
    <button className="nav--button" onClick={switchLogin}>
      <img src="/login.svg" alt="My profile" />
      <div>
        Login
      </div>
    </button>
  )
}

export default LoginButton;